export const projects = [
					{
						name: "Code Party",
						color: "blue",
						description: `This is an app similar to Meetups, but specifically for people looking to create projects together in a home environment.  Users can host a "Code Party" where users will get together and create projects using a specific technology, such as React or Vue.`,
						githubURL:
							"https://github.com/thorski1/CodePartyReact",
						siteURL:
							"https://codeparty-c6656.firebaseapp.com",
						image: "/assets/CodeParty.png",
					},
					{
						name: "Progress Blog",
						color: "blue",
						description: `This a blog that I post an update everyday about what and how I'm learning. I created this blog using Gatsby and Contentful`,
						githubURL:
							"https://github.com/thorski1/New-Gatsby-Progress-Blog",
						siteURL:
							"https://sam-thoyre-progress-blog.netlify.com/",
						image: "/assets/ProgressBlog2.png",
					},
					{
						name: "E-Commerce Clothing Store",
						color: "grey",
						description:
							"This is an incredibly comprehensive E-Commerce demo app that uses React, Redux, Firebase, and Stripe.",
						githubURL:
							"https://github.com/thorski1/ECommerceClothingReact",
						siteURL:
							"https://sams-crwn-clothing.herokuapp.com/",
						image: "/assets/CRWN.png",
					},
					{
						name: "Find Your Superhero",
						color: "blue",
						description:
							"This app was built using React with TypeScript. State is primarily managed with the Context/Reducer pattern.",
						githubURL:
							"https://github.com/thorski1/Superheroes",
						siteURL:
							"https://find-your-superhero.netlify.app",
						image: "/assets/superhero-project.png",
					},
					{
						name: "The News",
						color: "blue",
						description:
							"I built this site without any class components and several custom hooks.  I used Material UI, React-Router, and React Pose in the making of this app. It calls the News API to populate the news",
						githubURL:
							"https://github.com/thorski1/TheNewsReact",
						siteURL: "https://the-simple-news.netlify.com",
						image: "/assets/TheNews.png",
					},
					{
						name: "Social Media Comment Board",
						color: "orange",
						description:
							"This is a full stack MongoDB, Express, React, Node and GraphQL app with Apollo. Users can register for the app, create posts, delete posts, comment on posts, and like posts.",
						githubURL:
							"https://github.com/thorski1/MERNG-Client",
						siteURL:
							"https://friendly-lamport-7b2a3f.netlify.com/",
						image: "/assets/Comment.png",
					},
					{
						name: "Color Palette",
						color: "violet",
						description:
							"This project utilizes React, Material UI, and many other packages and serves as an aid in creating a color palette for developers",
						githubURL:
							"https://github.com/thorski1/ColorPaletteReact",
						siteURL:
							"https://objective-borg-49ef3d.netlify.com",
						image: "/assets/ColorPalette.png",
					},
					{
						name: "Star Wars",
						color: "yellow",
						description:
							"This project calls the Star Wars API and displays information about characters, films, species, starships, vehicles or planets, depending on what page you're on.  I created this using React, Reach Router, and Semantic UI",
						githubURL:
							"https://github.com/thorski1/StarWarsReact",
						siteURL: "https://star-wars.sthoyre.now.sh",
						image: "/assets/StarWars.png",
					},
					{
						name: "ToDo App with Custom Hooks",
						color: "green",
						description:
							"This is yet another To Do list, but made entirely with functional components and implementing 3 different custom hooks. It has the capabilities of retaining your information within the local storage, too!",
						githubURL:
							"https://github.com/thorski1/ToDoWithCustomHooks",
						siteURL: "https://todo-hooks.sthoyre.now.sh",
						image: "/assets/ToDoWithHooks.png",
					},
					{
						name: "Team Blog",
						color: "blue",
						description:
							"This another blog site created with Gatsby. The blog entries are created using Markdown and has some awesome features like adding comments and pagination.  This is meant for more than one person to add entries",
						githubURL:
							"https://github.com/thorski1/CodeBlogGatsby",
						siteURL:
							"https://musing-raman-5f01f9.netlify.com",
						image: "/assets/CodeBlog.png",
					},
					{
						name: "Dad Jokes",
						color: "green",
						description:
							"This app uses React and an API that has a database of cheesy jokes.  This project illustrates how to use lifecycle methods in conjunction with APIs.",
						githubURL:
							"https://github.com/thorski1/DadJokesReact",
						siteURL:
							"https://naughty-ritchie-720b3d.netlify.com",
						image: "/assets/DadJokes.png",
					},
					{
						name: "Florida's Breweries",
						color: "orange",
						description:
							"This is a map of 20 of Florida's breweries, made using Leaflet, Vue, Bootstrap, and OpenBreweryDB.org API",
						githubURL:
							"https://github.com/thorski1/FloridasBreweries",
						siteURL:
							"https://jovial-rosalind-d8799b.netlify.com",
						image: "/assets/Breweries.png",
					},
					{
						name: "Technologically Challenged Blog",
						color: "blue",
						description:
							"This is a blog created with Gatsby that will serve as a place for me to post technical blog articles",
						githubURL:
							"https://github.com/thorski1/Tech-Blog",
						siteURL:
							"https://technologically-challenged-blog.netlify.com",
						image: "/assets/TechBlog.png",
					},
					{
						name: "First Progress Blog",
						color: "purple",
						description: `This a blog that I post an update everyday about what and how I'm learning. I created this blog using Vue, Nuxt, and Storyblok CMS.`,
						githubURL:
							"https://github.com/thorski1/CodePartyReact",
						siteURL:
							"https://thorski1.github.io/ProgressBlog/",
						image: "/assets/ProgressBlog.png",
					},
					{
						name: "YelpCamp",
						color: "green",
						description:
							"This was the culminating project for the Web Developer Bootcamp, by Colt Steele, on Udemy. Please login and create a campsite!",
						githubURL:
							"https://github.com/thorski1/yelpcamp",
						siteURL:
							"https://still-chamber-95832.herokuapp.com",
						image: "/assets/YelpCamp.png",
					},
					{
						name: "Stock Trader",
						color: "blue",
						description: `This is the culminating project for Maximilian Schwarzmuller's "VueJS 2: The Complete Guide" and implements the fundamentals of Vue, along with Vue-resource and Vuex`,
						githubURL:
							"https://github.com/thorski1/StockTraderVue",
						siteURL:
							"https://sad-mcnulty-3949f7.netlify.com/",
						image: "/assets/StockTrader.png",
					},
					{
						name: "ToDo App with Hooks",
						color: "red",
						description:
							"This is a basic todo app with persistent state using local storage. I used React to make this with hooks, reducers, and context.",
						githubURL:
							"https://github.com/thorski1/TodoReactHooksContextReducers",
						siteURL:
							"https://hopeful-golick-e9cfeb.netlify.com",
						image: "/assets/HooksToDo.png",
					},
					{
						name: "Dice Roll",
						color: "violet",
						description:
							"This project served as a rudimentary introduction to state with React.",
						githubURL:
							"https://github.com/thorski1/RollDiceReact",
						siteURL:
							"https://tender-wiles-315784.netlify.com",
						image: "/assets/DiceRoll.png",
					},
					{
						name: "Pokedex Game",
						color: "yellow",
						description:
							"This is a Pokemon card game created using React and a Pokemon API from Github!",
						githubURL:
							"https://github.com/thorski1/PokedexGameReact",
						siteURL:
							"https://loving-lewin-36dede.netlify.com",
						image: "/assets/Pokedex.png",
					},
					{
						name: "Robot Rolodex",
						color: "blue",
						description: `This is the introductory project for Andrei Neagoie's "Complete React Developer in 2019," using the fundamentals of React.`,
						githubURL:
							"https://github.com/thorski1/RobotRolodexReact",
						siteURL:
							"https://upbeat-nightingale-a52f41.netlify.com",
						image: "/assets/RobotRolodex.png",
					},
					{
						name: "To Do List",
						color: "green",
						description:
							"This project demonstrates the basics of using React with forms!",
						githubURL:
							"https://github.com/thorski1/ToDoReact",
						siteURL:
							"https://jolly-raman-437342.netlify.com",
						image: "/assets/ToDoBasic.png",
					},
					{
						name: "Weather App",
						color: "blue",
						description:
							"This is a weather app that finds the temperature, humidity, and conditions of any city searched in the world, pulling information from OpenWeatherMap API.",
						githubURL:
							"https://github.com/thorski1/WeatherAppReact",
						siteURL:
							"https://weatherappreact-54pzgo7ut.now.sh/",
						image: "/assets/WeatherApp.png",
					},
					{
						name: "Coin Flip",
						color: "grey",
						description:
							"This app demonstrates the fundamentals of using state in React!",
						githubURL:
							"https://github.com/thorski1/CoinFlipReact",
						siteURL:
							"https://fervent-joliot-e87aaa.netlify.com",
						image: "/assets/CoinFlip.png",
					},
					{
						name: "Multilanguage Form",
						color: "pink",
						description:
							"This is a very basic form that actually doesn't do anything. However, you can toggle between dark and  light mode and also change the language of the content of the page.  This was all done first using class components with context  and then refactored to use hooks with context.",
						githubURL:
							"https://github.com/thorski1/MultiLanguageFormReactContextHooks",
						siteURL:
							"https://agitated-golick-6ee84c.netlify.com",
						image: "/assets/MultilanguageForm.png",
					},
					{
						name: "Random Card Generator",
						color: "grey",
						description:
							"This demo is meant to illustrate how to use APIs with React, using Axios and Lifecycle Methods!",
						githubURL:
							"https://github.com/thorski1/RandomCardGeneratorReact",
						siteURL:
							"https://youthful-galileo-f1b044.netlify.com",
						image: "/assets/RandomCardGenerator.png",
					},
					{
						name: "Lottery Balls",
						color: "blue",
						description: `This project demonstrates the correct use of React state patterns by using state in the parent component and only putting objects that will change in state.`,
						githubURL:
							"https://github.com/thorski1/LotteryBallsReact",
						siteURL:
							"https://admiring-dubinsky-ce00b9.netlify.com",
						image: "/assets/LotteryBall.png",
					},
					{
						name: "Dog List",
						color: "grey",
						description: `This app uses React with Bootstrap and demonstrates the correct use of React Router!`,
						githubURL:
							"https://github.com/thorski1/RobotRolodexReact",
						siteURL:
							"https://objective-brown-07211c.netlify.com/dogs",
						image: "/assets/DogList.png",
					},
					{
						name: "Search Recipes",
						color: "teal",
						description:
							"This app was created using React and a recipe searching API called Edamam!",
						githubURL:
							"https://github.com/thorski1/RecipeSearchApp",
						siteURL:
							"https://suspicious-swartz-f44c2e.netlify.com",
						image: "/assets/RecipeSearch.png",
					},
					{
						name: "Color Guessing Game",
						color: "green",
						description:
							"This app was created with just HTML and CSS, no JavaScript involved!",
						githubURL:
							"https://github.com/thorski1/ColorGuessingGame",
						siteURL:
							"https://kind-agnesi-388e43.netlify.com",
						image: "/assets/ColorGame.png",
					},
					{
						name: "Patatap Clone",
						color: "orange",
						description:
							"This is a clone of the Patatap app created using JavaScript, HTML, and CSS.",
						githubURL:
							"https://github.com/thorski1/PatatapClone",
						siteURL:
							"https://elastic-franklin-ebbf24.netlify.com",
						image: "/assets/Patatap.jpg",
					},
					{
						name: "Recipe Book",
						color: "violet",
						description:
							"This is a collection of my favorite recipes to make, mainly for me to easily access instead of having to search google every time I want to make a specific dish that I've made before. I made this with Vue and NuxtJS!",
						githubURL:
							"https://github.com/thorski1/SamsRecipeBook",
						siteURL:
							"https://nervous-noyce-ed5d28.netlify.com/",
						image: "/assets/RecipeBook.png",
					},
					{
						name: "Save Your Quotes",
						color: "blue",
						description:
							"This is a simple app made with Vue demonstrating the basic concepts of components and passing props between children, parents, and siblings!",
						githubURL:
							"https://github.com/thorski1/SaveYourQuotesVue",
						siteURL:
							"https://sad-spence-6bb2b0.netlify.com",
						image: "/assets/QuoteSaver.png",
					},
					{
						name: "Quote Generator",
						color: "orange",
						description:
							"A javascript/html/css project that displays a random pick of quotes from an array.",
						githubURL:
							"https://github.com/thorski1/FamousQuotesJS",
						siteURL:
							"https://thorski1.github.io/FamousQuotesJS/",
						image: "/assets/QuoteGenerator.png",
					},
					{
						name: "Background Color Changer",
						color: "teal",
						description:
							"A button that changes the background color of the site using JavaScript.",
						githubURL:
							"https://github.com/thorski1/ChangeBackgroundColor",
						siteURL:
							"https://thorski1.github.io/ChangeBackgroundColor/",
						image: "/assets/BackgroundColor.png",
					},
				];
